/**
 * Validates Segment Names -- Should only contain Alphanumeric, *, -, #, or $
 * @function isSegmentNameValid
 * @param {string} str
 * @return {boolean}
 */
const isSegmentNameValid = str => /^[-#$*\w\s]*$/.test(str);

export default isSegmentNameValid;
